import { render } from "./VangeIcon.vue?vue&type=template&id=487af264&ts=true"
import script from "./VangeIcon.vue?vue&type=script&lang=ts"
export * from "./VangeIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__